import { FC } from 'react';
import { FieldError } from 'react-hook-form';

import { Varmesentral } from '../../../../../utils/registerEnums';

import { EnumRadioButton } from './enumRadioButton';
import { EnumRadioGroup } from './enumRadioGroup';

interface Props {
  onChange: (value: Varmesentral) => void;
  error?: FieldError;
  value?: Varmesentral;
}

export const VarmesentralRadio: FC<Props> = ({ onChange, value, error }) => (
  <EnumRadioGroup
    error={error}
    value={value}
    onChange={(val) => onChange(val as Varmesentral)}
    labelKey="register.tekniskUtstyr.kjel.varmesentral.label"
    helperTextKey="register.varmesentral.kjel.information"
  >
    <EnumRadioButton i18nPrefix="register" value={Varmesentral.AutomatikkMedUtefolerTidsstyrt} />
    <EnumRadioButton i18nPrefix="register" value={Varmesentral.AutomatikkMedUtefolerIkkeTidsstyrt} />
    <EnumRadioButton i18nPrefix="register" value={Varmesentral.UtenAutomatikk} />
    <EnumRadioButton i18nPrefix="register" value={Varmesentral.Ukjent} />
  </EnumRadioGroup>
);
